import React from 'react';
import {
  ctaWrapperStyle,
  quizBtnDisabledStyle,
  quizCloseBtnStyle,
  quizCtaIconStyle,
  quizCtaStyle,
  quizSubmitBtnStyle
} from './QuizScreenStyles';
import { useAppStore } from '../../hooks/useAppStore';

const CloseIconSvg = () => {
  return (
    <svg
      css={quizCtaIconStyle}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.24 11.7733L8.46665 7.99999L12.24 4.22665C12.3733 4.09332 12.3733 3.88665 12.24 3.75332C12.1067 3.61999 11.9 3.61999 11.7667 3.75332L7.99332 7.52665L4.22665 3.75999C4.09332 3.62665 3.88665 3.62665 3.75332 3.75999C3.61999 3.89332 3.61999 4.09999 3.75332 4.23332L7.52665 8.00665L3.75332 11.78C3.61999 11.9133 3.61999 12.12 3.75332 12.2533C3.88665 12.3867 4.09332 12.3867 4.22665 12.2533L7.99999 8.47999L11.7733 12.2533C11.9067 12.3867 12.1133 12.3867 12.2467 12.2533C12.38 12.12 12.38 11.9133 12.2467 11.78L12.24 11.7733Z"
        fill="white"
      />
    </svg>
  );
};

const ChevronRightIconSvg = () => {
  return (
    <svg
      css={quizCtaIconStyle}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.06662 3.71334C6.93329 3.58001 6.72662 3.58001 6.59329 3.71334C6.45995 3.84668 6.45995 4.05334 6.59329 4.18668L10.4066 8.00001L6.59329 11.8133C6.45995 11.9467 6.45995 12.1533 6.59329 12.2867C6.72662 12.42 6.93329 12.42 7.06662 12.2867L11.12 8.23334C11.2533 8.10001 11.2533 7.89334 11.12 7.76001L7.06662 3.70668V3.71334Z"
        fill="white"
      />
    </svg>
  );
};

interface QuizControlsProps {
  isBtnDisabled: boolean;
  closeBtnHandler: (e: React.SyntheticEvent) => void;
  submitBtnHandler: (e: React.SyntheticEvent) => void;
  isLastQuestion: boolean;
}

const QuizControls: React.FC<QuizControlsProps> = ({
  isBtnDisabled,
  closeBtnHandler,
  submitBtnHandler,
  isLastQuestion
}) => {
  const { translations } = useAppStore();
  return (
    <div css={ctaWrapperStyle}>
      <button
        type="button"
        onClick={closeBtnHandler}
        css={[quizCtaStyle, quizCloseBtnStyle]}>
        <CloseIconSvg />
        {translations?.gamification?.CLOSE}
      </button>
      <button
        type="button"
        onClick={submitBtnHandler}
        css={[
          quizCtaStyle,
          quizSubmitBtnStyle,
          isBtnDisabled && quizBtnDisabledStyle
        ]}>
        {isBtnDisabled && <ChevronRightIconSvg />}
        {isLastQuestion
          ? translations?.gamification?.SUBMIT
          : translations?.gamification?.NEXT_QUESTION}
        {!isBtnDisabled && <ChevronRightIconSvg />}
      </button>
    </div>
  );
};

export default QuizControls;
